import { Button } from "antd"
import { ReactComponent as TryangleWarning } from '../../../../../assets/images/icon/tryangle-warning.svg';
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { beUsedIssuedCouponById, createEventCouponHistory, getBasicMemberByToken, requestTossPaymentConfirm } from "../../../../../service";
import { isIOS } from "react-device-detect";
import Success from '../../../../../assets/images/lottie/success.json';
import LoadingBig from '../../../../../assets/images/lottie/loading_big.json';
import Lottie from "lottie-react";
import { useMyContext } from "../../../../../entities/context";
import { paidProgram } from "../../../../../utils/gtm";
import { useGetProgramBookingWebByProgramBookingId } from "../../../../my/reservationHistory/detail/programBookingDetail/model";

const ProgramBookTossPayConfirm = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const orderId = searchParams.get("orderId");
    const programBookingId = searchParams.get("programBookingId");
    const amount = searchParams.get("amount")
    const paymentType = searchParams.get("paymentType");
    const paymentKey = searchParams.get("paymentKey");
    const usedPoint = searchParams.get("usedPoint");
    const selectedConselingBranch = searchParams.get("selectedConselingBranch");
    const [loading, setLoading] = useState<boolean>(false);
    const [isSuccess, setIsSuccess] = useState<boolean>();
    const [errorText, setErrorText] = useState<string>();
    const requestQuery = 'programId programBookingId programTitle programIsOnline targetDateTime programIsPaid'
    const { data } = useGetProgramBookingWebByProgramBookingId(Number(programBookingId), requestQuery)
    const { setMyReservationHistoryTabKey } = useMyContext();
    let memberId = '';

    const requestServerTossPaymentConfirm = async () => {
        if (!orderId || !paymentKey || !amount) {
            console.log("orderId", orderId)
            console.log("paymentKey", paymentKey)
            console.log("amount", amount)
            return alert('필수값이 없습니다.');
        }
        setLoading(true);
        try {
            const res = await requestTossPaymentConfirm(orderId, paymentKey, amount, Number(usedPoint), selectedConselingBranch ?? 'SEOLLEUNG')
            memberId = res.data.memberId;
            if (orderId.includes('_')) {
                await beUsedIssuedCouponById(orderId.split('_')[1], res.data.id);
            } else if (orderId.split('-').length - 1 === 3) {
                const params = {
                    memberId: res.data.memberId,
                    tossPayId: res.data.id,
                    eventCouponId: orderId.split('-')[3] as string
                }
                createEventCouponHistory(params)
            }
            setIsSuccess(true)
        } catch (error: any) {
            console.error('error', error);
            setErrorText(error.response.data)
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        requestServerTossPaymentConfirm();
    }, [])

    return <>
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            textAlign: 'center'
        }}>
            <div>
                <div>
                    {loading
                        ? <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Lottie
                                style={{ width: 100, height: 100 }}
                                animationData={LoadingBig}
                                autoplay={true}
                            />
                        </div>
                        : isSuccess === true
                            ? <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Lottie
                                    style={{ width: 100, height: 100 }}
                                    animationData={Success}
                                    loop={false}
                                    autoplay={true}
                                />
                            </div>
                            : <TryangleWarning width={100} height={100} fill="var(--secondarys400)" />}
                </div>
                <div className="sub-title/st5 base/black" style={{ marginTop: 10 }}>
                    {loading
                        ? '결제를 진행하고 있습니다'
                        : isSuccess === true
                            ? "결제가 완료되었습니다."
                            : '결제를 다시 진행해주세요'}
                </div>
                {loading
                    ? <div className="body/b3 secondary/s700">
                        잠시만 기다려주세요.
                    </div>
                    : isSuccess !== true &&
                    <div className="body/b3 secondary/s700">
                        {errorText}
                    </div>}
            </div>
        </div>
        <div style={{ margin: 20, paddingTop: '20px', position: 'absolute', bottom: '0px', width: 'calc(100% - 40px)', maxWidth: '440px', marginBottom: isIOS ? 46 : 20 }}>
            <Button
                disabled={loading}
                color="default"
                variant="solid"
                className="sub-title/st3 base/white"
                style={{ width: '100%', height: '51px', display: 'flex', alignItems: 'center', justifyContent: 'center', }}
                onClick={() => {
                    if (isSuccess === true) {
                        if (data) {
                            const title = data.programTitle;
                            const isPaid = data.programIsPaid ? '유료' : '무료'
                            const type = data.programIsOnline ? '온라인' : '오프라인';
                            const ticketName = data.programIsPaid ? data.programBookingTicketWebResponseList.map(q => q.programTicketName).join(',') : '-';
                            const quantity = data.programBookingTicketWebResponseList.reduce((acc, ticket) => acc + ticket.programBookingTicketCount, 0);
                            const price = data.programIsPaid ? data.programBookingTicketWebResponseList.reduce((acc, ticket) => acc + (ticket.programBookingTicketCount * ticket.programBookingTicketPrice), 0) : 0;
                            paidProgram(title, isPaid, type, ticketName, quantity, price, '', 0, price)
                        }

                        setMyReservationHistoryTabKey(1);
                        window.history.pushState({}, '', '/');
                        window.history.pushState({}, '', '/explore');
                        window.history.pushState({}, '', `/my`);
                        window.history.pushState({}, '', `/my/reservation-history/${memberId}`);
                        window.history.pushState({}, '', `/program/book/detail/${programBookingId}`);
                        navigate(`/program/book/detail/${programBookingId}`)
                        window.history.pushState({}, '', '/');
                        window.history.pushState({}, '', '/explore');
                        window.history.pushState({}, '', `/my`);
                        window.history.pushState({}, '', `/my/reservation-history/${memberId}`);
                        window.history.pushState({}, '', `/program/book/detail/${programBookingId}`);
                    } else {
                        navigate(-1)
                    }
                }}>
                {loading
                    ? '결제 중'
                    : isSuccess === true
                        ? '예약 내역 확인'
                        : '뒤로가기'}
            </Button>
        </div>
    </>
}

export default ProgramBookTossPayConfirm